import _ from 'lodash';
import geolib from 'geolib';

export default function groupMarkers(sourceMarkers, color) {
  const THRESHOLD_METERS = 25;
  const groupedMarkers = [];

  _.forEach(sourceMarkers, (currentMarker, index) => {
    // If first marker, push and return
    if (index === 0) {
      return groupedMarkers.push(currentMarker);
    }

    // Get last element in groupedMarkers
    const lastMarker = _.last(groupedMarkers);

    // Distance between last marker in groupedMarkers and currentMarker
    const distance = geolib.getDistance(
      {
        latitude: currentMarker.position.lat,
        longitude: currentMarker.position.lng,
      },
      {
        latitude: lastMarker.position.lat,
        longitude: lastMarker.position.lng,
      },
    );

    // If distance < THRESHOLD then merge current + next into one marker
    if (distance < THRESHOLD_METERS) {
      if (lastMarker.countOfCombinedMarkers) {
        lastMarker.countOfCombinedMarkers += 1;
      } else {
        lastMarker.countOfCombinedMarkers = 2;
      }
      const combinedMarker = _.merge({}, lastMarker, {
        markerStyle: { fillColor: color },
        labelText: `${index - (lastMarker.countOfCombinedMarkers - 1)}-${index}`,
        numberOfCombinedMarkers: lastMarker.countOfCombinedMarkers,
      });

      if (currentMarker.events) {
        combinedMarker.events = _.concat(
          lastMarker.events,
          currentMarker.events,
        );
      } else if (currentMarker.bikeLocations) {
        combinedMarker.bikeLocations = _.concat(
          lastMarker.bikeLocations,
          currentMarker.bikeLocations,
        );
      } else if (currentMarker.bleScans) {
        combinedMarker.bleScans = _.concat(
          lastMarker.bleScans,
          currentMarker.bleScans,
        );
      }

      // Pop off the last element and replace it
      groupedMarkers.pop();
      return groupedMarkers.push(combinedMarker);
    }
    // Else push the currentMarker
    return groupedMarkers.push(currentMarker);
  });

  return groupedMarkers;
}
